import { connect } from 'react-redux'
import Projects from './Projects'

import selectTableRows from './Selectors/selectTableRows'

import onChangeSort from './Handlers/onChangeSort'

const mapStateToProps = (state) => ({
  tableRows: selectTableRows(state),
  fetching: state.screens.Subbies.SubProjects.fetching,
  sortBy: state.screens.Subbies.SubProjects.sortBy,
})

const actionCreators = {
  onChangeSort,
}

export default connect(mapStateToProps, actionCreators)(Projects)
